import { MessageUserInfo } from '../../apis/messaging/messaging.interfaces';

export const mockUsers: MessageUserInfo[] = [
  {
    _id: 'mock_user',
    first_name: 'Mock',
    last_name: 'User',
    email: 'mock@example.com',
    profile_picture: '/images/mock.png',
  },
  {
    _id: 'u1',
    first_name: 'Helllo',
    last_name: 'World',
    email: 'naman@example.com',
    profile_picture: '/images/world.png',
  },
  {
    _id: 'u2',
    first_name: 'Hello',
    last_name: 'Universe',
    email: 'aryan@example.com',
    profile_picture: '/images/universe.png',
  },
];
